import * as React from 'react';
import RoutePrivate from 'src/components/router/RoutePrivate';
import ClientMaintentancePage from './pages/ClientMaintenancePage';
import ProjectMaintentancePage from './pages/ProjectMaintenancePage';
import ClientContactPage from './pages/ClientContact';
// import ManageClientBilling from '../project/sections/ManageClientBilling';
import ManageProjectBilling from './pages/ManageProjectBilling';
import ManageClientBilling from './pages/ManageClientBilling';
import SubcodeMaintenancePage from './pages/SubcodeMaintenancePage';
import ProjectStaffingPage from './pages/ProjectStaffing';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="client-project" path="/client-project/clientmaintenance" component={ClientMaintentancePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="client" path="/client-project/clientmaintenance" component={ClientMaintentancePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="clientcontact" path="/client-project/clientcontactmaintenance" component={ClientContactPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="clientcontact" path="/client-project/clientbillingmaintenance" component={ManageClientBilling} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="project" path="/client-project/projectmaintenance" component={ProjectMaintentancePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="project" path="/client-project/projectbillingmaintenance" component={ManageProjectBilling} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="project" path="/client-project/projectstaffing" component={ProjectStaffingPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="project" path="/client-project/subcodemaintenance" component={SubcodeMaintenancePage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="client" path="/client-project/clientmaintenance" component={ClientMaintentancePage} isLoggedIn={isLoggedIn} />
    ];
}



// WEBPACK FOOTER //
// ./src/components/client-project/CP.Routes.tsx